export type RoomData = ReturnType<typeof room>;

const STEPS = 8;

export const ROOM_DATA: Record<string, RoomData> = Object.fromEntries(
  [
    room("01", "12:41 PM", "Vacant", "Closed", 0, 3, 72, "Idle"),
    room("02", "12:44 PM", "Occupied", "Open", 0, 14, 69, "Cooling"),
    room("03", "12:47 PM", "Occupied", "Closed", 0, 20, 70, "Cooling"),
    room("04", "12:39 PM", "Vacant", "Closed", 1, 6, 74, "Heating"),
    room("05", "12:46 PM", "Occupied", "Closed", 0, 17, 71, "Cooling"),
    room("06", "12:32 PM", "Vacant", "Closed", 0, 2, 72, "Idle"),
    room("07", "12:45 PM", "Occupied", "Closed", 0, 11, 68, "Heating"),
    room("08", "12:36 PM", "Vacant", "Open", 0, 4, 72, "Idle"),
    room("09", "12:43 PM", "Occupied", "Closed", 0, 22, 70, "Cooling"),
    room("10", "12:40 PM", "Vacant", "Closed", 1, 5, 73, "Heating"),
    room("11", "12:47 PM", "Occupied", "Closed", 0, 16, 71, "Cooling"),
    room("12", "12:30 PM", "Vacant", "Closed", 0, 3, 72, "Idle"),
  ].map((data) => [data.id, data]),
);

function room(
  slot: string,
  time: string,
  occupancy: "Occupied" | "Vacant",
  door: "Open" | "Closed",
  alerts: number,
  kw: number,
  setpointF: number,
  mode: "Cooling" | "Heating" | "Idle",
) {
  const seed = Number(slot);
  const drift = { Cooling: 1, Heating: -1, Idle: 0 }[mode];
  return {
    id: `2-${slot}`,
    name: `Room 2${slot}`,
    time: `Sep 14, ${time}`,
    occupancy,
    door,
    alerts,
    mode,
    kw,
    energy: steps(kw, seed, kw * 0.4),
    currentF: setpointF + drift,
    setpointF,
    tempSeries: steps(setpointF + drift, seed + 3, 2),
    setpointSeries: Array.from({ length: STEPS }, (_, i) =>
      i < STEPS / 2 ? setpointF + 2 * drift : setpointF,
    ),
  };
}

// Deterministic so every visit shows the same history, ending on `end`.
function steps(end: number, seed: number, spread: number) {
  return Array.from({ length: STEPS }, (_, i) =>
    i === STEPS - 1 ? end : Math.round(end + Math.sin(seed + i * 1.9) * spread),
  );
}
